import { createReducer } from 'redux-act';
import actions from '../actions/pmsActions';

const initialState = {
    createKraPending: false,
    createKraRes: null,
    createKraError: null,

    getKraDetailsPending: false,
    getKraDetailsRes: null,
    getKraDetailsError: null,

    getAllKraDetailsDataPending: false,
    getAllKraDetailsDataRes: null,
    getAllKraDetailsDataError: null,

    updateKraDetailPending: false,
    updateKraDetailRes: null,
    updateKraDetailError: null,

    deleteKraDetailPending: false,
    deleteKraDetailRes: null,
    deleteKraDetailError: null,

    createKraParameterPending: false,
    createKraParameterRes: null,
    createKraParameterError: null,

    getKraParameterPending: false,
    getKraParameterRes: null,
    getKraParameterError: null,

    getAllKraParameterDataPending: false,
    getAllKraParameterDataRes: null,
    getAllKraParameterDataError: null,

    updateKraParameterPending: false,
    updateKraParameterRes: null,
    updateKraParameterError: null,

    deleteKraParameterPending: false,
    deleteKraParameterRes: null,
    deleteKraParameterError: null,

    createKPiDetailsPending: false,
    createKPiDetailsRes: null,
    createKPiDetailsError: null,

    getKPiDetailsPending: false,
    getKPiDetailsRes: null,
    getKPiDetailsError: null,

    getAllKpiDetailsDataPending: false,
    getAllKpiDetailsDataRes: null,
    getAllKpiDetailsDataError: null,

    updateKpiDetailPending: false,
    updateKpiDetailRes: null,
    updateKpiDetailError: null,

    deleteKpiDetailPending: false,
    deleteKpiDetailRes: null,
    deleteKpiDetailError: null,

    createKraRatingTypeForDepartmentPending: false,
    createKraRatingTypeForDepartmentRes: null,
    createKraRatingTypeForDepartmentError: null,

    getKraRatingTypeForDepartmentPending: false,
    getKraRatingTypeForDepartmentRes: null,
    getKraRatingTypeForDepartmentError: null,

    getAllKraRatingTypeForDepartmentPending: false,
    getAllKraRatingTypeForDepartmentRes: null,
    getAllKraRatingTypeForDepartmentError: null,

    updateKraRatingTypeForDepartmentPending: false,
    updateKraRatingTypeForDepartmentRes: null,
    updateKraRatingTypeForDepartmentError: null,

    deleteKraRatingTypeForDepartmentPending: false,
    deleteKraRatingTypeForDepartmentRes: null,
    deleteKraRatingTypeForDepartmentError: null,


    createSelfRatingPermissionPending: false,
    createSelfRatingPermissionRes: null,
    createSelfRatingPermissionError: null,

    getSelfRatingPermissionPending: false,
    getSelfRatingPermissionRes: null,
    getSelfRatingPermissionError: null,

    getAllSelfRatingPermissionPending: false,
    getAllSelfRatingPermissionRes: null,
    getAllSelfRatingPermissionError: null,

    updateSelfRatingPermissionPending: false,
    updateSelfRatingPermissionRes: null,
    updateSelfRatingPermissionError: null,

    deleteSelfRatingPermissionPending: false,
    deleteSelfRatingPermissionRes: null,
    deleteSelfRatingPermissionError: null,

    assignKraPending: false,
    assignKraRes: null,
    assignKraError: null,

    getAssignKraPending: false,
    getAssignKraRes: null,
    getAssignKraError: null,

    getAllAssignKraPending: false,
    getAllAssignKraRes: null,
    getAllAssignKraError: null,

    updateAssignKraPending: false,
    updateAssignKraRes: null,
    updateAssignKraError: null,

    deleteAssignKraPending: false,
    deleteAssignKraRes: null,
    deleteAssignKraError: null,

    getEmployeeByKraPending: false,
    getEmployeeByKraRes: null,
    getEmployeeByKraError: null,

    giveRatingPending: false,
    giveRatingRes: null,
    giveRatingError: null,

    getGivenRatingPending: false,
    getGivenRatingRes: null,
    getGivenRatingError: null,

    updateRatingDurationPending: false,
    updateRatingDurationRes: null,
    updateRatingDurationError: null,

    getKraDetailsByEmployeePending: false,
    getKraDetailsByEmployeeRes: null,
    getKraDetailsByEmployeeError: null,

    getRatingWiseEmployeePending: false,
    getRatingWiseEmployeeRes: null,
    getRatingWiseEmployeeError: null,
    
    getAverageRatingPending: false,
    getAverageRatingRes: null,
    getAverageRatingError: null,

    selectedKraDetailData: null


};
/* Create KraReducers */
const handleCreateKraRequest = state => {
    return {
        ...state,
        ...{
            createKraPending: true,
            createKraRes: null,
            createKraError: null,
        },
    };
};
const handleCreateKraSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createKraPending: false,
            createKraRes: payload,
            createKraError: null,
        },
    };
};
const handleCreateKraError = (state, payload) => ({
    ...state,
    ...{
        createKraPending: false,
        createKraRes: null,
        createKraError: payload,
    },
});

/* Get Kra Details Reducers */
const handleGetKraDetailsRequest = state1 => {
    return {
        ...state1,
        ...{
            getKraDetailsPending: true,
            getKraDetailsRes: null,
            getKraDetailsError: null,
        },
    };
};
const handleGetKraDetailsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKraDetailsPending: false,
            getKraDetailsRes: payload,
            getKraDetailsError: null,
        },
    };
};
const handleGetKraDetailsError = (state1, payload) => ({
    ...state1,
    ...{
        getKraDetailsPending: false,
        getKraDetailsRes: null,
        getKraDetailsError: payload,
    },
});

/* Get All Kra Details Data Reducers */
const handleAllGetKraDetailsDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllKraDetailsDataPending: true,
            getAllKraDetailsDataRes: null,
            getAllKraDetailsDataError: null,
        },
    };
};
const handleAllGetKraDetailsDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllKraDetailsDataPending: false,
            getAllKraDetailsDataRes: payload,
            getAllKraDetailsDataError: null,
        },
    };
};
const handleAllGetKraDetailsDataError = (state1, payload) => ({
    ...state1,
    ...{
        getAllKraDetailsDataPending: false,
        getAllKraDetailsDataRes: null,
        getAllKraDetailsDataError: payload,
    },
});

/* Update Kra Detail Reducers */
const handleUpdateKraDetailRequest = state1 => {
    return {
        ...state1,
        ...{
            updateKraDetailPending: true,
            updateKraDetailRes: null,
            updateKraDetailError: null,
        },
    };
};
const handleUpdateKraDetailSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateKraDetailPending: false,
            updateKraDetailRes: payload,
            updateKraDetailError: null,
        },
    };
};
const handleUpdateKraDetailError = (state1, payload) => ({
    ...state1,
    ...{
        updateKraDetailPending: false,
        updateKraDetailRes: null,
        updateKraDetailError: payload,
    },
});

/* Delete Kra Detail Reducers*/
const handleDeleteKraDetailRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteKraDetailPending: true,
            deleteKraDetailRes: null,
            deleteKraDetailError: null,
        },
    };
};
const handleDeleteKraDetailSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteKraDetailPending: false,
            deleteKraDetailRes: payload,
            deleteKraDetailError: null,
        },
    };
};
const handleDeleteKraDetailError = (state1, payload) => ({
    ...state1,
    ...{
        deleteKraDetailPending: false,
        deleteKraDetailRes: null,
        deleteKraDetailError: payload,
    },
});

/* Create Kra Parameter Reducers */
const handleCreateKraParameterRequest = state1 => {
    return {
        ...state1,
        ...{
            createKraParameterPending: true,
            createKraParameterRes: null,
            createKraParameterError: null,
        },
    };
};
const handleCreateKraParameterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createKraParameterPending: false,
            createKraParameterRes: payload,
            createKraParameterError: null,
        },
    };
};
const handleCreateKraParameterError = (state1, payload) => ({
    ...state1,
    ...{
        createKraParameterPending: false,
        createKraParameterRes: null,
        createKraParameterError: payload,
    },
});

/* Get Kra Parameter Reducers */
const handleGetKraParameterRequest = state1 => {
    return {
        ...state1,
        ...{
            getKraParameterPending: true,
            getKraParameterRes: null,
            getKraParameterError: null,
        },
    };
};
const handleGetKraParameterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKraParameterPending: false,
            getKraParameterRes: payload,
            getKraParameterError: null,
        },
    };
};
const handleGetKraParameterError = (state1, payload) => ({
    ...state1,
    ...{
        getKraParameterPending: false,
        getKraParameterRes: null,
        getKraParameterError: payload,
    },
});

/* Get All Kra Parameter Data Reducers */
const handleGetAllKraParameterDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllKraParameterDataPending: true,
            getAllKraParameterDataRes: null,
            getAllKraParameterDataError: null,
        },
    };
};
const handleGetAllKraParameterDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllKraParameterDataPending: false,
            getAllKraParameterDataRes: payload,
            getAllKraParameterDataError: null,
        },
    };
};
const handleGetAllKraParameterDataError = (state1, payload) => ({
    ...state1,
    ...{
        getAllKraParameterDataPending: false,
        getAllKraParameterDataRes: null,
        getAllKraParameterDataError: payload,
    },
});


/* Update Kra Parameter Reducers */
const handleUpdateKraParameterRequest = state1 => {
    return {
        ...state1,
        ...{
            updateKraParameterPending: true,
            updateKraParameterRes: null,
            updateKraParameterError: null,
        },
    };
};
const handleUpdateKraParameterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateKraParameterPending: false,
            updateKraParameterRes: payload,
            updateKraParameterError: null,
        },
    };
};
const handleUpdateKraParameterError = (state1, payload) => ({
    ...state1,
    ...{
        updateKraParameterPending: false,
        updateKraParameterRes: null,
        updateKraParameterError: payload,
    },
});

/* Delete Kra Parameter Reducers */
const handleDeleteKraParameterRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteKraParameterPending: true,
            deleteKraParameterRes: null,
            deleteKraParameterError: null,
        },
    };
};
const handleDeleteKraParameterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteKraParameterPending: false,
            deleteKraParameterRes: payload,
            deleteKraParameterError: null,
        },
    };
};
const handleDeleteKraParameterError = (state1, payload) => ({
    ...state1,
    ...{
        deleteKraParameterPending: false,
        deleteKraParameterRes: null,
        deleteKraParameterError: payload,
    },
});

/* Create KPi Details Reducers */
const handleCreateKPiDetailsRequest = state1 => {
    return {
        ...state1,
        ...{
            createKPiDetailsPending: true,
            createKPiDetailsRes: null,
            createKPiDetailsError: null,
        },
    };
};
const handleCreateKPiDetailsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createKPiDetailsPending: false,
            createKPiDetailsRes: payload,
            createKPiDetailsError: null,
        },
    };
};
const handleCreateKPiDetailsError = (state1, payload) => ({
    ...state1,
    ...{
        createKPiDetailsPending: false,
        createKPiDetailsRes: null,
        createKPiDetailsError: payload,
    },
});

/* Create KPi Details Reducers */
const handleGetKpiDetailsRequest = state1 => {
    return {
        ...state1,
        ...{
            getKpiDetailsPending: true,
            getKpiDetailsRes: null,
            getKpiDetailsError: null,
        },
    };
};
const handleGetKpiDetailsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKpiDetailsPending: false,
            getKpiDetailsRes: payload,
            getKpiDetailsError: null,
        },
    };
};
const handleGetKpiDetailsError = (state1, payload) => ({
    ...state1,
    ...{
        getKpiDetailsPending: false,
        getKpiDetailsRes: null,
        getKpiDetailsError: payload,
    },
});

/* Get All Kpi Details Data Reducers */
const handleGetAllKpiDetailsDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllKpiDetailsDataPending: true,
            getAllKpiDetailsDataRes: null,
            getAllKpiDetailsDataError: null,
        },
    };
};
const handleGetAllKpiDetailsDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllKpiDetailsDataPending: false,
            getAllKpiDetailsDataRes: payload,
            getAllKpiDetailsDataError: null,
        },
    };
};
const handleGetAllKpiDetailsDataError = (state1, payload) => ({
    ...state1,
    ...{
        getAllKpiDetailsDataPending: false,
        getAllKpiDetailsDataRes: null,
        getAllKpiDetailsDataError: payload,
    },
});


/* Update KPi Details Reducers */
const handleUpdateKpiDetailRequest = state1 => {
    return {
        ...state1,
        ...{
            updateKpiDetailPending: true,
            updateKpiDetailRes: null,
            updateKpiDetailError: null,
        },
    };
};
const handleUpdateKpiDetailSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateKpiDetailPending: false,
            updateKpiDetailRes: payload,
            updateKpiDetailError: null,
        },
    };
};
const handleUpdateKpiDetailError = (state1, payload) => ({
    ...state1,
    ...{
        updateKpiDetailPending: false,
        updateKpiDetailRes: null,
        updateKpiDetailError: payload,
    },
});

/* Update KPi Details Reducers */
const handleDeleteKpiDetailRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteKpiDetailPending: true,
            deleteKpiDetailRes: null,
            deleteKpiDetailError: null,
        },
    };
};
const handleDeleteKpiDetailSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteKpiDetailPending: false,
            deleteKpiDetailRes: payload,
            deleteKpiDetailError: null,
        },
    };
};
const handleDeleteKpiDetailError = (state1, payload) => ({
    ...state1,
    ...{
        deleteKpiDetailPending: false,
        deleteKpiDetailRes: null,
        deleteKpiDetailError: payload,
    },
});

/*Create Kra Rating Type For Department Reducers */
const handleCreateKraRatingTypeForDepartmentRequest = state1 => {
    return {
        ...state1,
        ...{
            createKraRatingTypeForDepartmentPending: true,
            createKraRatingTypeForDepartmentRes: null,
            createKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleCreateKraRatingTypeForDepartmentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createKraRatingTypeForDepartmentPending: false,
            createKraRatingTypeForDepartmentRes: payload,
            createKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleCreateKraRatingTypeForDepartmentError = (state1, payload) => ({
    ...state1,
    ...{
        createKraRatingTypeForDepartmentPending: false,
        createKraRatingTypeForDepartmentRes: null,
        createKraRatingTypeForDepartmentError: payload,
    },
});

/*Get Kra Rating Type For Department Reducers */
const handleGetKraRatingTypeForDepartmentRequest = state1 => {
    return {
        ...state1,
        ...{
            getKraRatingTypeForDepartmentPending: true,
            getKraRatingTypeForDepartmentRes: null,
            getKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleGetKraRatingTypeForDepartmentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKraRatingTypeForDepartmentPending: false,
            getKraRatingTypeForDepartmentRes: payload,
            getKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleGetKraRatingTypeForDepartmentError = (state1, payload) => ({
    ...state1,
    ...{
        getKraRatingTypeForDepartmentPending: false,
        getKraRatingTypeForDepartmentRes: null,
        getKraRatingTypeForDepartmentError: payload,
    },
});

/*Create Kra Rating Type For Department Reducers */
const handleGetAllKraRatingTypeForDepartmentRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllKraRatingTypeForDepartmentPending: true,
            getAllKraRatingTypeForDepartmentRes: null,
            getAllKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleGetAllKraRatingTypeForDepartmentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllKraRatingTypeForDepartmentPending: false,
            getAllKraRatingTypeForDepartmentRes: payload,
            getAllKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleGetAllKraRatingTypeForDepartmentError = (state1, payload) => ({
    ...state1,
    ...{
        getAllKraRatingTypeForDepartmentPending: false,
        getAllKraRatingTypeForDepartmentRes: null,
        getAllKraRatingTypeForDepartmentError: payload,
    },
});

/*Update Kra Rating Type For Department Reducers */
const handleUpdateKraRatingTypeForDepartmentRequest = state1 => {
    return {
        ...state1,
        ...{
            updateKraRatingTypeForDepartmentPending: true,
            updateKraRatingTypeForDepartmentRes: null,
            updateKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleUpdateKraRatingTypeForDepartmentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateKraRatingTypeForDepartmentPending: false,
            updateKraRatingTypeForDepartmentRes: payload,
            updateKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleUpdateKraRatingTypeForDepartmentError = (state1, payload) => ({
    ...state1,
    ...{
        updateKraRatingTypeForDepartmentPending: false,
        updateKraRatingTypeForDepartmentRes: null,
        updateKraRatingTypeForDepartmentError: payload,
    },
});

/*Delete Kra Rating Type For Department Reducers */
const handleDeleteKraRatingTypeForDepartmentRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteKraRatingTypeForDepartmentPending: true,
            deleteKraRatingTypeForDepartmentRes: null,
            deleteKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleDeleteKraRatingTypeForDepartmentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteKraRatingTypeForDepartmentPending: false,
            deleteKraRatingTypeForDepartmentRes: payload,
            deleteKraRatingTypeForDepartmentError: null,
        },
    };
};
const handleDeleteKraRatingTypeForDepartmentError = (state1, payload) => ({
    ...state1,
    ...{
        deleteKraRatingTypeForDepartmentPending: false,
        deleteKraRatingTypeForDepartmentRes: null,
        deleteKraRatingTypeForDepartmentError: payload,
    },
});


/*Create SelfRatingPermission Reducers */
const handleCreateSelfRatingPermissionRequest = state1 => {
    return {
        ...state1,
        ...{
            createSelfRatingPermissionPending: true,
            createSelfRatingPermissionRes: null,
            createSelfRatingPermissionError: null,
        },
    };
};
const handleCreateSelfRatingPermissionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            createSelfRatingPermissionPending: false,
            createSelfRatingPermissionRes: payload,
            createSelfRatingPermissionError: null,
        },
    };
};
const handleCreateSelfRatingPermissionError = (state1, payload) => ({
    ...state1,
    ...{
        createSelfRatingPermissionPending: false,
        createSelfRatingPermissionRes: null,
        createSelfRatingPermissionError: payload,
    },
});

/*Get SelfRatingPermission  Reducers */
const handleGetSelfRatingPermissionRequest = state1 => {
    return {
        ...state1,
        ...{
            getSelfRatingPermissionPending: true,
            getSelfRatingPermissionRes: null,
            getSelfRatingPermissionError: null,
        },
    };
};
const handleGetSelfRatingPermissionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getSelfRatingPermissionPending: false,
            getSelfRatingPermissionRes: payload,
            getSelfRatingPermissionError: null,
        },
    };
};
const handleGetSelfRatingPermissionError = (state1, payload) => ({
    ...state1,
    ...{
        getSelfRatingPermissionPending: false,
        getSelfRatingPermissionRes: null,
        getSelfRatingPermissionError: payload,
    },
});

/*Create All SelfRatingPermission Reducers */
const handleGetAllSelfRatingPermissionRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllSelfRatingPermissionPending: true,
            getAllSelfRatingPermissionRes: null,
            getAllSelfRatingPermissionError: null,
        },
    };
};
const handleGetAllSelfRatingPermissionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllSelfRatingPermissionPending: false,
            getAllSelfRatingPermissionRes: payload,
            getAllSelfRatingPermissionError: null,
        },
    };
};
const handleGetAllSelfRatingPermissionError = (state1, payload) => ({
    ...state1,
    ...{
        getAllSelfRatingPermissionPending: false,
        getAllSelfRatingPermissionRes: null,
        getAllSelfRatingPermissionError: payload,
    },
});

/*Update Self Rating Permission Reducers */
const handleUpdateSelfRatingPermissionRequest = state1 => {
    return {
        ...state1,
        ...{
            updateSelfRatingPermissionPending: true,
            updateSelfRatingPermissionRes: null,
            updateSelfRatingPermissionError: null,
        },
    };
};
const handleUpdateSelfRatingPermissionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateSelfRatingPermissionPending: false,
            updateSelfRatingPermissionRes: payload,
            updateSelfRatingPermissionError: null,
        },
    };
};
const handleUpdateSelfRatingPermissionError = (state1, payload) => ({
    ...state1,
    ...{
        updateSelfRatingPermissionPending: false,
        updateSelfRatingPermissionRes: null,
        updateSelfRatingPermissionError: payload,
    },
});

/*Delete Self Rating Permission Reducers */
const handleDeleteSelfRatingPermissionRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteSelfRatingPermissionPending: true,
            deleteSelfRatingPermissionRes: null,
            deleteSelfRatingPermissionError: null,
        },
    };
};
const handleDeleteSelfRatingPermissionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteSelfRatingPermissionPending: false,
            deleteSelfRatingPermissionRes: payload,
            deleteSelfRatingPermissionError: null,
        },
    };
};
const handleDeleteSelfRatingPermissionError = (state1, payload) => ({
    ...state1,
    ...{
        deleteSelfRatingPermissionPending: false,
        deleteSelfRatingPermissionRes: null,
        deleteSelfRatingPermissionError: payload,
    },
});

/*Create Assign Kra Reducers */
const handleAssignKraRequest = state1 => {
    return {
        ...state1,
        ...{
            assignKraPending: true,
            assignKraRes: null,
            assignKraError: null,
        },
    };
};
const handleAssignKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assignKraPending: false,
            assignKraRes: payload,
            assignKraError: null,
        },
    };
};
const handleAssignKraError = (state1, payload) => ({
    ...state1,
    ...{
        assignKraPending: false,
        assignKraRes: null,
        assignKraError: payload,
    },
});

/*Get Assign Kra Reducers */
const handleGetAssignKraRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssignKraPending: true,
            getAssignKraRes: null,
            getAssignKraError: null,
        },
    };
};
const handleGetAssignKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssignKraPending: false,
            getAssignKraRes: payload,
            getAssignKraError: null,
        },
    };
};
const handleGetAssignKraError = (state1, payload) => ({
    ...state1,
    ...{
        getAssignKraPending: false,
        getAssignKraRes: null,
        getAssignKraError: payload,
    },
});

/*Create Assign Kra Reducers */
const handleGetAllAssignKraRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllAssignKraPending: true,
            getAllAssignKraRes: null,
            getAllAssignKraError: null,
        },
    };
};
const handleGetAllAssignKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllAssignKraPending: false,
            getAllAssignKraRes: payload,
            getAllAssignKraError: null,
        },
    };
};
const handleGetAllAssignKraError = (state1, payload) => ({
    ...state1,
    ...{
        getAllAssignKraPending: false,
        getAllAssignKraRes: null,
        getAllAssignKraError: payload,
    },
});

/*Update Assign Kra Reducers */
const handleUpdateAssignKraRequest = state1 => {
    return {
        ...state1,
        ...{
            updateAssignKraPending: true,
            updateAssignKraRes: null,
            updateAssignKraError: null,
        },
    };
};
const handleUpdateAssignKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateAssignKraPending: false,
            updateAssignKraRes: payload,
            updateAssignKraError: null,
        },
    };
};
const handleUpdateAssignKraError = (state1, payload) => ({
    ...state1,
    ...{
        updateAssignKraPending: false,
        updateAssignKraRes: null,
        updateAssignKraError: payload,
    },
});

/*Delete Assign Kra Reducers */
const handleDeleteAssignKraRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteAssignKraPending: true,
            deleteAssignKraRes: null,
            deleteAssignKraError: null,
        },
    };
};
const handleDeleteAssignKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteAssignKraPending: false,
            deleteAssignKraRes: payload,
            deleteAssignKraError: null,
        },
    };
};
const handleDeleteAssignKraError = (state1, payload) => ({
    ...state1,
    ...{
        deleteAssignKraPending: false,
        deleteAssignKraRes: null,
        deleteAssignKraError: payload,
    },
});

/*Get Employee By Kra Reducers */
const handleGetEmployeeByKraRequest = state1 => {
    return {
        ...state1,
        ...{
            getEmployeeByKraPending: true,
            getEmployeeByKraRes: null,
            getEmployeeByKraError: null,
        },
    };
};
const handleGetEmployeeByKraSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getEmployeeByKraPending: false,
            getEmployeeByKraRes: payload,
            getEmployeeByKraError: null,
        },
    };
};
const handleGetEmployeeByKraError = (state1, payload) => ({
    ...state1,
    ...{
        getEmployeeByKraPending: false,
        getEmployeeByKraRes: null,
        getEmployeeByKraError: payload,
    },
});

/*give Rating Reducers */
const handleGiveRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            giveRatingPending: true,
            giveRatingRes: null,
            giveRatingError: null,
        },
    };
};
const handleGiveRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            giveRatingPending: false,
            giveRatingRes: payload,
            giveRatingError: null,
        },
    };
};
const handleGiveRatingError = (state1, payload) => ({
    ...state1,
    ...{
        giveRatingPending: false,
        giveRatingRes: null,
        giveRatingError: payload,
    },
});

/*Get Given RatingReducers */
const handleGetGivenRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            getGivenRatingPending: true,
            getGivenRatingRes: null,
            getGivenRatingError: null,
        },
    };
};
const handleGetGivenRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getGivenRatingPending: false,
            getGivenRatingRes: payload,
            getGivenRatingError: null,
        },
    };
};
const handleGetGivenRatingError = (state1, payload) => ({
    ...state1,
    ...{
        getGivenRatingPending: false,
        getGivenRatingRes: null,
        getGivenRatingError: payload,
    },
});

/* Update Rating Duration Reducers */
const handleUpdateRatingDurationRequest = state1 => {
    return {
        ...state1,
        ...{
            updateRatingDurationPending: true,
            updateRatingDurationRes: null,
            updateRatingDurationError: null,
        },
    };
};
const handleUpdateRatingDurationSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateRatingDurationPending: false,
            updateRatingDurationRes: payload,
            updateRatingDurationError: null,
        },
    };
};
const handleUpdateRatingDurationError = (state1, payload) => ({
    ...state1,
    ...{
        updateRatingDurationPending: false,
        updateRatingDurationRes: null,
        updateRatingDurationError: payload,
    },
});

/* Get Kra Details By Employee Reducers */
const handleGetKraDetailsByEmployeeRequest = state1 => {
    return {
        ...state1,
        ...{
            getKraDetailsByEmployeePending: true,
            getKraDetailsByEmployeeRes: null,
            getKraDetailsByEmployeeError: null,
        },
    };
};
const handleGetKraDetailsByEmployeeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getKraDetailsByEmployeePending: false,
            getKraDetailsByEmployeeRes: payload,
            getKraDetailsByEmployeeError: null,
        },
    };
};
const handleGetKraDetailsByEmployeeError = (state1, payload) => ({
    ...state1,
    ...{
        getKraDetailsByEmployeePending: false,
        getKraDetailsByEmployeeRes: null,
        getKraDetailsByEmployeeError: payload,
    },
});

/* Get Rating Wise Employee Reducers */
const handleGetRatingWiseEmployeeRequest = state1 => {
    return {
        ...state1,
        ...{
            getRatingWiseEmployeePending: true,
            getRatingWiseEmployeeRes: null,
            getRatingWiseEmployeeError: null,
        },
    };
};
const handleGetRatingWiseEmployeeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getRatingWiseEmployeePending: false,
            getRatingWiseEmployeeRes: payload,
            getRatingWiseEmployeeError: null,
        },
    };
};
const handleGetRatingWiseEmployeeError = (state1, payload) => ({
    ...state1,
    ...{
        getRatingWiseEmployeePending: false,
        getRatingWiseEmployeeRes: null,
        getRatingWiseEmployeeError: payload,
    },
});

/* Get Average Rating Reducers */
const handleGetAverageRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            getAverageRatingPending: true,
            getAverageRatingRes: null,
            getAverageRatingError: null,
        },
    };
};
const handleGetAverageRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAverageRatingPending: false,
            getAverageRatingRes: payload,
            getAverageRatingError: null,
        },
    };
};
const handleGetAverageRatingError = (state1, payload) => ({
    ...state1,
    ...{
        getAverageRatingPending: false,
        getAverageRatingRes: null,
        getAverageRatingError: payload,
    },
});



const handleSelectedKraDetailData = (state1, payload) => ({
    ...state1,
    ...{
        selectedKraDetailData: payload,
    }

});



// Clear Existing Data Store Reducers*/
const clearPMSStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_CREATE_KRA_STORE':
            return {
                ...state,
                ...{
                    createKraPending: false,
                    createKraRes: null,
                    createKraError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_DETAIL_STORE':
            return {
                ...state,
                ...{
                    updateKraDetailPending: false,
                    updateKraDetailRes: null,
                    updateKraDetailError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_KRA_DETAIL_STORE':
            return {
                ...state,
                ...{
                    deleteKraDetailPending: false,
                    deleteKraDetailRes: null,
                    deleteKraDetailError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_KRA_DETAILS_STORE':
            return {
                ...state,
                ...{
                    getKraDetailsPending: false,
                    getKraDetailsRes: null,
                    getKraDetailsError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_KRA_PARAMETER_STORE':
            return {
                ...state,
                ...{
                    createKraParameterPending: false,
                    createKraParameterRes: null,
                    createKraParameterError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_PARAMETER_STORE':
            return {
                ...state,
                ...{
                    updateKraParameterPending: false,
                    updateKraParameterRes: null,
                    updateKraParameterError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_KRA_PARAMETER_STORE':
            return {
                ...state,
                ...{
                    deleteKraParameterPending: false,
                    deleteKraParameterRes: null,
                    deleteKraParameterError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_PARAMETER_STORE':
            return {
                ...state,
                ...{
                    updateKraParameterPending: false,
                    updateKraParameterRes: null,
                    updateKraParameterError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_KPI_DETAILS_STORE':
            return {
                ...state,
                ...{
                    createKPiDetailsPending: false,
                    createKPiDetailsRes: null,
                    createKPiDetailsError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_KPI_DETAILS_STORE':
            return {
                ...state,
                ...{
                    getKPiDetailsPending: false,
                    getKPiDetailsRes: null,
                    getKPiDetailsError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KPI_DETAIL_STORE':
            return {
                ...state,
                ...{
                    updateKpiDetailPending: false,
                    updateKpiDetailRes: null,
                    updateKpiDetailError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_KPI_DETAIL_STORE':
            return {
                ...state,
                ...{
                    deleteKpiDetailPending: false,
                    deleteKpiDetailRes: null,
                    deleteKpiDetailError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    createKraRatingTypeForDepartmentPending: false,
                    createKraRatingTypeForDepartmentRes: null,
                    createKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    getKraRatingTypeForDepartmentPending: false,
                    getKraRatingTypeForDepartmentRes: null,
                    getKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    deleteKraRatingTypeForDepartmentPending: false,
                    deleteKraRatingTypeForDepartmentRes: null,
                    deleteKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    getAllKraRatingTypeForDepartmentPending: false,
                    getAllKraRatingTypeForDepartmentRes: null,
                    getAllKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    updateKraRatingTypeForDepartmentPending: false,
                    updateKraRatingTypeForDepartmentRes: null,
                    updateKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    updateKraRatingTypeForDepartmentPending: false,
                    updateKraRatingTypeForDepartmentRes: null,
                    updateKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_ASSIGN_KRA_STORE':
            return {
                ...state,
                ...{
                    assignKraPending: false,
                    assignKraRes: null,
                    assignKraError: null,

                },
            };
        case 'HANDLE_CLEAR_UPDATE_ASSIGN_KRA_STORE':
            return {
                ...state,
                ...{
                    updateAssignKraPending: false,
                    updateAssignKraRes: null,
                    updateAssignKraError: null,

                },
            };

        case 'HANDLE_CLEAR_DELETE_ASSIGN_KRA_STORE':
            return {
                ...state,
                ...{
                    deleteAssignKraPending: false,
                    deleteAssignKraRes: null,
                    deleteAssignKraError: null,

                },
            };
        case 'HANDLE_CLEAR_UPDATE_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    updateKraRatingTypeForDepartmentPending: false,
                    updateKraRatingTypeForDepartmentRes: null,
                    updateKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_RATING_DURATION_STORE':
            return {
                ...state,
                ...{
                    updateRatingDurationPending: false,
                    updateRatingDurationRes: null,
                    updateRatingDurationError: null,
                },
            };
        case 'HANDLE_CLEAR_GIVE_RATING_STORE':
            return {
                ...state,
                ...{
                    giveRatingPending: false,
                    giveRatingRes: null,
                    giveRatingError: null,
                },
            };

        case 'HANDLE_CLEAR_GET_GIVE_RATING_STORE':
            return {
                ...state,
                ...{
                    getGivenRatingPending: false,
                    getGivenRatingRes: null,
                    getGivenRatingError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_SELF_RATING_PERMISSION_STORE':
            return {
                ...state,
                ...{
                    updateSelfRatingPermissionPending: false,
                    updateSelfRatingPermissionRes: null,
                    updateSelfRatingPermissionError: null,
                },
            };
        case 'HANDLE_CLEAR_GET_ALL_KRA_RATING_TYPE_FOR_DEPARTMENT_STORE':
            return {
                ...state,
                ...{
                    getAllKraRatingTypeForDepartmentPending: false,
                    getAllKraRatingTypeForDepartmentRes: null,
                    getAllKraRatingTypeForDepartmentError: null,
                },
            };
        case 'HANDLE_CLEAR_SELECTED_KRA_DETAIL_DATA_STORE':
            return {
                ...state,
                ...{

                    selectedKraDetailData: null,

                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.createKraRequest]: handleCreateKraRequest,
        [actions.createKraSuccess]: handleCreateKraSuccess,
        [actions.createKraError]: handleCreateKraError,

        [actions.getKraDetailsRequest]: handleGetKraDetailsRequest,
        [actions.getKraDetailsSuccess]: handleGetKraDetailsSuccess,
        [actions.getKraDetailsError]: handleGetKraDetailsError,

        [actions.getAllKraDetailsDataRequest]: handleAllGetKraDetailsDataRequest,
        [actions.getAllKraDetailsDataSuccess]: handleAllGetKraDetailsDataSuccess,
        [actions.getAllKraDetailsDataError]: handleAllGetKraDetailsDataError,

        [actions.updateKraDetailRequest]: handleUpdateKraDetailRequest,
        [actions.updateKraDetailSuccess]: handleUpdateKraDetailSuccess,
        [actions.updateKraDetailError]: handleUpdateKraDetailError,

        [actions.deleteKraDetailRequest]: handleDeleteKraDetailRequest,
        [actions.deleteKraDetailSuccess]: handleDeleteKraDetailSuccess,
        [actions.deleteKraDetailError]: handleDeleteKraDetailError,

        [actions.createKraParameterRequest]: handleCreateKraParameterRequest,
        [actions.createKraParameterSuccess]: handleCreateKraParameterSuccess,
        [actions.createKraParameterError]: handleCreateKraParameterError,

        [actions.getKraParameterRequest]: handleGetKraParameterRequest,
        [actions.getKraParameterSuccess]: handleGetKraParameterSuccess,
        [actions.getKraParameterError]: handleGetKraParameterError,

        [actions.getAllKraParameterDataRequest]: handleGetAllKraParameterDataRequest,
        [actions.getAllKraParameterDataSuccess]: handleGetAllKraParameterDataSuccess,
        [actions.getAllKraParameterDataError]: handleGetAllKraParameterDataError,

        [actions.updateKraParameterRequest]: handleUpdateKraParameterRequest,
        [actions.updateKraParameterSuccess]: handleUpdateKraParameterSuccess,
        [actions.updateKraParameterError]: handleUpdateKraParameterError,

        [actions.deleteKraParameterRequest]: handleDeleteKraParameterRequest,
        [actions.deleteKraParameterSuccess]: handleDeleteKraParameterSuccess,
        [actions.deleteKraParameterError]: handleDeleteKraParameterError,

        [actions.createKPiDetailsRequest]: handleCreateKPiDetailsRequest,
        [actions.createKPiDetailsSuccess]: handleCreateKPiDetailsSuccess,
        [actions.createKPiDetailsError]: handleCreateKPiDetailsError,

        [actions.getKpiDetailsRequest]: handleGetKpiDetailsRequest,
        [actions.getKpiDetailsSuccess]: handleGetKpiDetailsSuccess,
        [actions.getKpiDetailsError]: handleGetKpiDetailsError,

        [actions.getAllKpiDetailsDataRequest]: handleGetAllKpiDetailsDataRequest,
        [actions.getAllKpiDetailsDataSuccess]: handleGetAllKpiDetailsDataSuccess,
        [actions.getAllKpiDetailsDataError]: handleGetAllKpiDetailsDataError,

        [actions.updateKpiDetailRequest]: handleUpdateKpiDetailRequest,
        [actions.updateKpiDetailSuccess]: handleUpdateKpiDetailSuccess,
        [actions.updateKpiDetailError]: handleUpdateKpiDetailError,

        [actions.deleteKpiDetailRequest]: handleDeleteKpiDetailRequest,
        [actions.deleteKpiDetailSuccess]: handleDeleteKpiDetailSuccess,
        [actions.deleteKpiDetailError]: handleDeleteKpiDetailError,


        [actions.createKraRatingTypeForDepartmentRequest]: handleCreateKraRatingTypeForDepartmentRequest,
        [actions.createKraRatingTypeForDepartmentSuccess]: handleCreateKraRatingTypeForDepartmentSuccess,
        [actions.createKraRatingTypeForDepartmentError]: handleCreateKraRatingTypeForDepartmentError,

        [actions.getKraRatingTypeForDepartmentRequest]: handleGetKraRatingTypeForDepartmentRequest,
        [actions.getKraRatingTypeForDepartmentSuccess]: handleGetKraRatingTypeForDepartmentSuccess,
        [actions.getKraRatingTypeForDepartmentError]: handleGetKraRatingTypeForDepartmentError,

        [actions.getAllKraRatingTypeForDepartmentRequest]: handleGetAllKraRatingTypeForDepartmentRequest,
        [actions.getAllKraRatingTypeForDepartmentSuccess]: handleGetAllKraRatingTypeForDepartmentSuccess,
        [actions.getAllKraRatingTypeForDepartmentError]: handleGetAllKraRatingTypeForDepartmentError,

        [actions.updateKraRatingTypeDepartmentRequest]: handleUpdateKraRatingTypeForDepartmentRequest,
        [actions.updateKraRatingTypeDepartmentSuccess]: handleUpdateKraRatingTypeForDepartmentSuccess,
        [actions.updateKraRatingTypeDepartmentError]: handleUpdateKraRatingTypeForDepartmentError,

        [actions.deleteKraRatingTypeForDepartmentRequest]: handleDeleteKraRatingTypeForDepartmentRequest,
        [actions.deleteKraRatingTypeForDepartmentSuccess]: handleDeleteKraRatingTypeForDepartmentSuccess,
        [actions.deleteKraRatingTypeForDepartmentError]: handleDeleteKraRatingTypeForDepartmentError,


        [actions.createSelfRatingPermissionRequest]: handleCreateSelfRatingPermissionRequest,
        [actions.createSelfRatingPermissionSuccess]: handleCreateSelfRatingPermissionSuccess,
        [actions.createSelfRatingPermissionError]: handleCreateSelfRatingPermissionError,

        [actions.getSelfRatingPermissionRequest]: handleGetSelfRatingPermissionRequest,
        [actions.getSelfRatingPermissionSuccess]: handleGetSelfRatingPermissionSuccess,
        [actions.getSelfRatingPermissionError]: handleGetSelfRatingPermissionError,

        [actions.getAllSelfRatingPermissionRequest]: handleGetAllSelfRatingPermissionRequest,
        [actions.getAllSelfRatingPermissionSuccess]: handleGetAllSelfRatingPermissionSuccess,
        [actions.getAllSelfRatingPermissionError]: handleGetAllSelfRatingPermissionError,

        [actions.updateSelfRatingPermissionRequest]: handleUpdateSelfRatingPermissionRequest,
        [actions.updateSelfRatingPermissionSuccess]: handleUpdateSelfRatingPermissionSuccess,
        [actions.updateSelfRatingPermissionError]: handleUpdateSelfRatingPermissionError,

        [actions.deleteSelfRatingPermissionRequest]: handleDeleteSelfRatingPermissionRequest,
        [actions.deleteSelfRatingPermissionSuccess]: handleDeleteSelfRatingPermissionSuccess,
        [actions.deleteSelfRatingPermissionError]: handleDeleteSelfRatingPermissionError,

        [actions.assignKraRequest]: handleAssignKraRequest,
        [actions.assignKraSuccess]: handleAssignKraSuccess,
        [actions.assignKraError]: handleAssignKraError,

        [actions.getAssignKraRequest]: handleGetAssignKraRequest,
        [actions.getAssignKraSuccess]: handleGetAssignKraSuccess,
        [actions.getAssignKraError]: handleGetAssignKraError,

        [actions.getAllAssignKraRequest]: handleGetAllAssignKraRequest,
        [actions.getAllAssignKraSuccess]: handleGetAllAssignKraSuccess,
        [actions.getAllAssignKraError]: handleGetAllAssignKraError,

        [actions.updateAssignKraRequest]: handleUpdateAssignKraRequest,
        [actions.updateAssignKraSuccess]: handleUpdateAssignKraSuccess,
        [actions.updateAssignKraError]: handleUpdateAssignKraError,

        [actions.deleteAssignKraRequest]: handleDeleteAssignKraRequest,
        [actions.deleteAssignKraSuccess]: handleDeleteAssignKraSuccess,
        [actions.deleteAssignKraError]: handleDeleteAssignKraError,

        [actions.getEmployeeByKraRequest]: handleGetEmployeeByKraRequest,
        [actions.getEmployeeByKraSuccess]: handleGetEmployeeByKraSuccess,
        [actions.getEmployeeByKraError]: handleGetEmployeeByKraError,

        [actions.giveRatingRequest]: handleGiveRatingRequest,
        [actions.giveRatingSuccess]: handleGiveRatingSuccess,
        [actions.giveRatingError]: handleGiveRatingError,

        [actions.getGivenRatingRequest]: handleGetGivenRatingRequest,
        [actions.getGivenRatingSuccess]: handleGetGivenRatingSuccess,
        [actions.getGivenRatingError]: handleGetGivenRatingError,

        [actions.updateRatingDurationRequest]: handleUpdateRatingDurationRequest,
        [actions.updateRatingDurationSuccess]: handleUpdateRatingDurationSuccess,
        [actions.updateRatingDurationError]: handleUpdateRatingDurationError,

        [actions.getKraDetailsByEmployeeRequest]: handleGetKraDetailsByEmployeeRequest,
        [actions.getKraDetailsByEmployeeSuccess]: handleGetKraDetailsByEmployeeSuccess,
        [actions.getKraDetailsByEmployeeError]: handleGetKraDetailsByEmployeeError,
        
        [actions.getRatingWiseEmployeeRequest]: handleGetRatingWiseEmployeeRequest,
        [actions.getRatingWiseEmployeeSuccess]: handleGetRatingWiseEmployeeSuccess,
        [actions.getRatingWiseEmployeeError]: handleGetRatingWiseEmployeeError,

        [actions.getAverageRatingRequest]: handleGetAverageRatingRequest,
        [actions.getAverageRatingSuccess]: handleGetAverageRatingSuccess,
        [actions.getAverageRatingError]: handleGetAverageRatingError,

        [actions.selectedKraDetailData]: handleSelectedKraDetailData,
        [actions.handleClearPMSStore]: clearPMSStore,
    },
    initialState,
);